import React from "react";
import { CreditMonthsInterface } from "../../intrefaces/credit/credit.interface";
import { CreditState } from "../../stores/credit/credit-state.interface";
import { Service } from "./Service";
import { useCreditSelector } from "../../stores/product/product.store";

interface ServicesProps {
    month: CreditMonthsInterface;
}

export const Services: React.FC<ServicesProps> = ({  month }) => {
    const translateText = useCreditSelector((state: CreditState) => state.text);

    return (
        <>
            { month?.requireServices?.length && <div className="mb-6">
                <p className="text-gray text-sm mb-4">{ translateText.advantages } { month.monthly } { translateText.leiMonth }</p>
                { month.requireServices.map(service => <Service key={ service.id } service={ service } isRequire={ true } />) }
            </div> }
            { month?.additionServices?.length &&  <div>
                <p className="text-gray text-sm mb-4">Дополнительные услуги</p>
                { month.additionServices.map(service => <Service key={ service.id } service={ service } />) }
            </div> }
        </>
    )
}